<div style="overflow: auto; height: calc(100vh - 220px)">
    <p class="text-muted small mt-2">
        These are suggestions and are not saved. The code is the first word of the invoice equipment field, matched to Viewpoint equipment, including
        retired units.
    </p>
    <div class="row action-toolbar">
        <div class="col-12">
            <form class="form-inline">
                <action-toolbar-count [grid]="unitGrid"></action-toolbar-count>
                <grid-export [grid]="gridPurchasedEquipment" [name]="'Purchased Material Equipment'"></grid-export>
            </form>
        </div>
    </div>
    <grid-column-group [grid]="unitGrid"></grid-column-group>
    <wj-flex-grid
        id="gridPurchasedEquipment"
        #gridPurchasedEquipment
        style="height: 280px"
        [isReadOnly]="true"
        (initialized)="unitGrid.initialize(gridPurchasedEquipment)"
        (destroy)="unitGrid.destroy()"
        (selectionChanged)="showLines()"
        [itemsSource]="unitGrid.view"
    >
        <wj-flex-grid-filter></wj-flex-grid-filter>
        <wj-flex-grid-column [header]="'Equipment'" [binding]="'equipment'" [width]="130" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Description'" [binding]="'description'" [width]="260" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Category'" [binding]="'category'" [width]="140" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Status'" [binding]="'status'" [width]="110" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Lines'" [binding]="'lineCount'" [width]="90" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Spend'" [binding]="'spend'" [width]="130" [format]="'c2'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Top items'" [binding]="'topItems'" [width]="320" [isReadOnly]="true"></wj-flex-grid-column>
    </wj-flex-grid>
    <grid-selection-calculation [grid]="gridPurchasedEquipment"></grid-selection-calculation>

    <h5 class="mt-3">Selected unit</h5>
    <div class="row action-toolbar">
        <div class="col-12">
            <form class="form-inline">
                <action-toolbar-count [grid]="lineGrid"></action-toolbar-count>
                <grid-export [grid]="gridEquipmentLines" [name]="'Purchased Material Equipment Lines'"></grid-export>
            </form>
        </div>
    </div>
    <grid-column-group [grid]="lineGrid"></grid-column-group>
    <wj-flex-grid
        id="gridEquipmentLines"
        #gridEquipmentLines
        style="height: 220px"
        [isReadOnly]="true"
        (initialized)="lineGrid.initialize(gridEquipmentLines)"
        (destroy)="lineGrid.destroy()"
        [itemsSource]="lineGrid.view"
    >
        <wj-flex-grid-filter></wj-flex-grid-filter>
        <wj-flex-grid-column [header]="'Description'" [binding]="'description'" [width]="360" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Category'" [binding]="'category'" [width]="140" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Lines'" [binding]="'lineCount'" [width]="90" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Spend'" [binding]="'spend'" [width]="130" [format]="'c2'" [isReadOnly]="true"></wj-flex-grid-column>
    </wj-flex-grid>
    <grid-selection-calculation [grid]="gridEquipmentLines"></grid-selection-calculation>

    <h5 class="mt-3">Unmatched codes</h5>
    <div class="row action-toolbar">
        <div class="col-12">
            <form class="form-inline">
                <action-toolbar-count [grid]="unmatchedGrid"></action-toolbar-count>
                <grid-export [grid]="gridUnmatchedEquipment" [name]="'Purchased Material Unmatched Equipment'"></grid-export>
            </form>
        </div>
    </div>
    <grid-column-group [grid]="unmatchedGrid"></grid-column-group>
    <wj-flex-grid
        id="gridUnmatchedEquipment"
        #gridUnmatchedEquipment
        style="height: 220px"
        [isReadOnly]="true"
        (initialized)="unmatchedGrid.initialize(gridUnmatchedEquipment)"
        (destroy)="unmatchedGrid.destroy()"
        [itemsSource]="unmatchedGrid.view"
    >
        <wj-flex-grid-filter></wj-flex-grid-filter>
        <wj-flex-grid-column [header]="'Code'" [binding]="'code'" [width]="140" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Example'" [binding]="'example'" [width]="220" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Lines'" [binding]="'lineCount'" [width]="90" [format]="'n0'" [isReadOnly]="true"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Spend'" [binding]="'spend'" [width]="130" [format]="'c2'" [isReadOnly]="true"></wj-flex-grid-column>
    </wj-flex-grid>
    <grid-selection-calculation [grid]="gridUnmatchedEquipment"></grid-selection-calculation>
</div>
